export default __webpack_public_path__ + "static/media/Bookingnw.44444c0b.png";